import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import simplePromise from './middleware/simple-promise';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();
const promiseMiddleware = simplePromise();

export default function configureStore(initialState, history) {
  const middleware =
    process.env.NODE_ENV !== 'production'
      ? [thunk, promiseMiddleware, sagaMiddleware]
      : [thunk, promiseMiddleware, sagaMiddleware];

  // Do not run the dev tools in production
  const composeEnhancers =
    process.env.NODE_ENV !== 'production'
      ? composeWithDevTools(applyMiddleware(...middleware))
      : applyMiddleware(...middleware);

  const reducer = rootReducer(history);
  const store = createStore(reducer, initialState, composeEnhancers);

  sagaMiddleware.run(rootSaga);

  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
